import React, { useState, useEffect } from 'react';
import api from '../api/axios';

const AdminPollResults = () => {
    const [activePoll, setActivePoll] = useState(null);
    const [stats, setStats] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchActivePoll();
        const interval = setInterval(fetchActivePoll, 3000);
        return () => clearInterval(interval);
    }, []);

    const fetchActivePoll = async () => {
        try {
            const res = await api.get('/polls/active');
            setActivePoll(res.data);
            if (res.data) {
                const statRes = await api.get(`/polls/${res.data.id}/stats`);
                setStats(statRes.data);
            } else {
                setStats(null);
            }
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) return (
        <div className="flex items-center justify-center h-[60vh]">
            <div className="w-12 h-12 border-4 border-slate-200 border-t-blue-600 rounded-full animate-spin"></div>
        </div>
    );

    if (!activePoll) return (
        <div className="bg-white rounded-[40px] shadow-sm border border-slate-100 p-20 text-center animate-fadeIn">
            <div className="text-6xl mb-6 opacity-20">📊</div>
            <h3 className="text-xl font-bold text-slate-800 uppercase tracking-tighter">Sin Votaciones Activas</h3>
            <p className="text-slate-400 mt-2 text-sm font-medium">Los resultados aparecerán aquí cuando el Staff publique una pregunta.</p>
        </div>
    );

    return (
        <div className="animate-fadeIn space-y-8">
            <div className="bg-white rounded-[40px] shadow-2xl border border-slate-100 p-12 overflow-hidden relative">
                <div className="flex justify-between items-start mb-12">
                    <div>
                        <span className="bg-blue-600 text-white text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-[0.2em] shadow-lg shadow-blue-500/30">Votación en Tiempo Real</span>
                        <h1 className="text-4xl font-black text-slate-900 mt-6 tracking-tight leading-tight max-w-4xl">
                            {activePoll.question}
                        </h1>
                    </div>
                    <div className="flex gap-4">
                        <div className="text-right">
                            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Participación</p>
                            <p className="text-3xl font-black text-blue-600">
                                {stats?.totalUsers > 0 ? Math.round((stats.totalVotes / stats.totalUsers) * 100) : 0}%
                            </p>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-3 gap-6 mb-12">
                    <div className="bg-slate-50 p-8 rounded-[30px] border border-slate-100">
                        <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Total Usuarios</p>
                        <p className="text-4xl font-black text-slate-900">{stats?.totalUsers || 0}</p>
                    </div>
                    <div className="bg-slate-50 p-8 rounded-[30px] border border-slate-100">
                        <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Votos Recibidos</p>
                        <div className="flex items-baseline gap-2">
                            <p className="text-4xl font-black text-emerald-500">{stats?.totalVotes || 0}</p>
                            <span className="text-slate-300 font-bold">Votos</span>
                        </div>
                    </div>
                    <div className="bg-blue-600 p-8 rounded-[30px] text-white shadow-xl shadow-blue-900/20">
                        <p className="text-[10px] font-black text-white/60 uppercase tracking-widest mb-2">Estado</p>
                        <p className="text-4xl font-black uppercase tracking-tighter">Activa</p>
                    </div>
                </div>

                <div className="space-y-10">
                    {stats?.results.map((res, index) => {
                        const percent = stats.totalVotes > 0 ? Math.round((res.votes / stats.totalVotes) * 100) : 0;
                        const colors = ['from-blue-600 to-indigo-600', 'from-purple-600 to-pink-600', 'from-emerald-500 to-teal-500', 'from-orange-500 to-amber-500'];
                        const colorClass = colors[index % colors.length];

                        return (
                            <div key={res.id} className="group">
                                <div className="flex justify-between items-end mb-4">
                                    <div className="flex items-center gap-4">
                                        <span className="w-8 h-8 rounded-full bg-slate-900 text-white flex items-center justify-center font-black text-xs">{index + 1}</span>
                                        <span className="text-xl font-bold text-slate-700">{res.option_text}</span>
                                    </div>
                                    <div className="text-right">
                                        <span className="block text-3xl font-black text-slate-900">{percent}%</span>
                                        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{res.votes} Votos</span>
                                    </div>
                                </div>
                                <div className="w-full h-8 bg-slate-100 rounded-2xl overflow-hidden p-1 shadow-inner">
                                    <div 
                                        className={`h-full bg-gradient-to-r ${colorClass} rounded-xl transition-all duration-1000 ease-out shadow-lg`}
                                        style={{ width: `${percent}%` }}
                                    ></div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <p className="text-center text-slate-400 text-[10px] font-bold uppercase tracking-widest">
                Actualización automática cada 3 segundos • Datos sincronizados con base de datos central
            </p>
        </div>
    );
};

export default AdminPollResults;
